import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NoosFormTypeService} from '../../../../../class/NoosFormTypeService';
import {IFormItems} from '../../../../../interface/form-structure';
import {IViewComponent} from '../../../../../interface/panels';

@Component({
    selector: 'noos-view-container-masterlist',
    templateUrl: './view-container-masterlist.component.html',
    styleUrls: ['./view-container-masterlist.component.scss']
})

@NoosFormTypeService.register('ViewVIEWmasterlist')
export class ViewContainerMasterlistComponent implements OnInit, IViewComponent, AfterViewInit {

    formJson: IFormItems[];
    isFilter: boolean;

    @Output()
    keyOnEnter = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    constructor() {
    }

    ngOnInit() {
    }

    ngAfterViewInit(): void {
    }


    onEnterEvent($event: any) {
        this.keyOnEnter.emit();
    }

}
